// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1pqPG","author":"Table_author__1Q1-x","authorImage":"Table_authorImage__2B89a","unreadRow":"Table_unreadRow__23jzX"};